// extracted by mini-css-extract-plugin
export default {"centered":"AnimatedNote_centered__XhwsG","note":"AnimatedNote_note__lYnhe","from":"AnimatedNote_from__-o-PE","to":"AnimatedNote_to__dJAn8","text":"AnimatedNote_text__xHvMz"};